import React from "react";
import { GoogleOAuthProvider, GoogleLogin, useGoogleOneTapLogin } from "@react-oauth/google";
import GoogleLoginService from "../../service/GoogleLoginService";

const GoogleLoginButton = ({ text, oneTapLogin = false }) => {

  const { handleGoogleSuccess } = GoogleLoginService()
  const handleGoogleFailure = (error) => {
    console.error("Google OAuth Error:", error);
    if (error?.type === "popup_closed_by_user") {
      alert("Please allow popups for this site.");
    } else {
      alert("Google login failed. Please try again.");
    }
  };
  const GoogleOneTapLogin = () => {
    useGoogleOneTapLogin({
      onSuccess: handleGoogleSuccess,
      onError: handleGoogleFailure,
    });

    return null; // No UI needed for One Tap
  };
  return (
    <div className="w-full flex justify-center items-center flex-col">
      {!oneTapLogin &&
        <p className="border-t text-slate-500 border-gray-500 w-full text-center">
          or
        </p>}

      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENTID}>
        {/* <div className="w-full flex justify-center items-center flex-col">
        <p className="border-t text-slate-500 border-gray-500 w-full text-center my-2">or</p> */}

        {oneTapLogin ? (
          <>
            <GoogleOneTapLogin />
          </>
        ) : (<>
          <GoogleOneTapLogin />
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleFailure}
            text={text}
            width="100%"
            size="large"
            useOneTap={false}
          />
        </>
        )}
        {/* </div> */}
      </GoogleOAuthProvider>
    </div>
  );
};

export default GoogleLoginButton;
